// Matched child route so ThemedApp catch-all does not redirect mobile panel URLs.
const OverviewMobileRouteShell = () => null;

export default OverviewMobileRouteShell;
